import { useSelector } from "react-redux";
import Container from "@material-ui/core/Container";
import LpCollectionOfExamples from "../LpCollectionOfExamples/LpCollectionOfExamples";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Hidden,
  Typography,
} from "@material-ui/core";
import { baseUrl } from "../Api/Api";
import React, { useEffect, useState } from "react";
import FormDialogPayment from "../FormDialogPayment/FormDialogPayment";
import { formatPrice } from "../Utils/Utils";
import Button from "@material-ui/core/Button";
import { getCookieConsentValue } from "react-cookie-consent";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import GetAppIcon from "@material-ui/icons/GetApp";
import TextField from "@material-ui/core/TextField";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import axios from "axios";

const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

const CollectionOfExamplesExample = (props) => {
  const { course } = props;
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [unlocked, setUnlocked] = useState(false);

  const handleUnlock = () => {
    setUnlocked(true);

    const data = {
      email: email,
    };
    const url = baseUrl + "/collection-of-examples/subscribe";
    axios.post(url, data);
  };

  useEffect(() => {
    setError("");
    if (email.length > 0) {
      if (!validateEmail(email)) {
        setError("E-mail nemá správný formát.");
      }
    }
  }, [email]);

  return (
    <>
      <Box style={{ display: "flex", position: "relative" }}>
        <Box
          component={"img"}
          src={"/collection-of-examples-1.png"}
          style={{ width: 357, margin: 10 }}
        />
        <Hidden mdDown={true}>
          <Box
            component={"img"}
            src={"/collection-of-examples-2.png"}
            style={{ width: 357, margin: 10 }}
          />
        </Hidden>

        <Box
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button
            variant={"contained"}
            color={"primary"}
            size={"large"}
            onClick={() => {
              setOpen(true);
            }}
          >
            Stáhnout ukázku
          </Button>
        </Box>
      </Box>
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <DialogTitle>Stáhnout ukázku</DialogTitle>
        <DialogContent>
          {!unlocked && (
            <>
              <DialogContentText>
                Zadejte svůj e-mail a stáhněte si ukázku
              </DialogContentText>
              <TextField
                style={{ marginTop: 16 }}
                label="E-mail"
                name="email"
                placeholder={"E-mail"}
                variant="outlined"
                required
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={email}
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
                helperText={error}
              />
              <Box style={{ marginTop: 16, textAlign: "center" }}>
                <Button
                  color={"primary"}
                  variant={"contained"}
                  disabled={error !== "" || email === ""}
                  onClick={() => {
                    handleUnlock();
                  }}
                >
                  Odeslat e-mail
                </Button>
              </Box>
            </>
          )}
          {unlocked && (
            <>
              <DialogContentText>
                Díky! Nyní si můžeš stáhnout ukázku
              </DialogContentText>
              <Box style={{ marginTop: 16, textAlign: "center" }}>
                <a
                  href={
                    baseUrl +
                    "/files/" +
                    course.collectionOfExamples.pdfPreviewFiles[0].slug
                  }
                >
                  <Button variant={"contained"} color={"primary"}>
                    Stáhnout ukázku
                  </Button>
                </a>
              </Box>
            </>
          )}
        </DialogContent>

        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

const CollectionOfExamples = (props) => {
  const theme = useSelector((state) => state.app.theme);

  const { classes, course } = props;

  const sendDataToGTM = useGTMDispatch();

  const [unlocked, setUnlocked] = useState(false);

  const unlockCourse = (token) => {
    setUnlocked(true);
    if (!!course && getCookieConsentValue() === "true") {
      const data = {
        event: "purchase",
        ecommerce: {
          transaction_id: Date.now(), // Unikátní ID transakce ('id' z datové vrstvy)
          value: course.price * 1, // Cena kurzu (nutné do DL propisovat číselnou hodnotu, ne string)
          currency: "CZK", // Měna transakce (pokud není a nebude jiná, nechat pouze CZK)
          tax: 0.0, // Pokud je DPH nebo jiný daňový parametr
          items: [
            {
              course_category_main: course.category.schoolType.slug, // Hlavní kategorie kurzu
              course_category: course.category.title, // Kategorii kurzu
              course_name: course.title, // Specifický název kurzu
              course_id: course.id, // Jedinečné ID kurzu
              price: course.price * 1, // Cena kurzu
              quantity: 1, // Počet zakoupených kurzů (pokud je vždy 1, můžete to vynechat)
              course_type: course.courseType.code, // Typ kurzu, pokud je to video
            },
          ],
        },
      };
      sendDataToGTM(data);
    }
  };

  return (
    <Container className={"landingPageView"}>
      <Box style={{ display: "flex", marginBottom: 48 }}>
        <Box style={{ flexGrow: 1 }}>
          <Typography variant={"h1"}>{course.title}</Typography>
          <Typography variant={"h2"}>
            {course.collectionOfExamples.subtitle}
          </Typography>
          <Typography>{course.description}</Typography>
          <Box style={{ paddingTop: 64 }} />
          <Box>
            {unlocked && (
              <Box>
                <a
                  href={
                    baseUrl +
                    "/files/" +
                    course.collectionOfExamples.pdfFiles[0].slug
                  }
                >
                  <Button
                    variant={"contained"}
                    color={"primary"}
                    size={"large"}
                    startIcon={<GetAppIcon />}
                  >
                    Stáhnout sbírku
                  </Button>
                </a>
              </Box>
            )}
            {!unlocked && (
              <>
                <Box style={{ fontSize: 30, fontWeight: 600 }}>
                  {formatPrice(course.price)}
                </Box>
                <FormDialogPayment
                  course={course}
                  unlockCourse={unlockCourse}
                  loggedInNeeded={false}
                />
              </>
            )}
          </Box>
        </Box>
        <Box style={{ paddingLeft: 32, paddingRight: 32 }}>
          <Box
            component={"img"}
            src={
              baseUrl +
                "/uploads/files/" +
                course?.collectionOfExamples?.thumbnailImageFiles[0]
                  ?.fileName || ""
            }
            alt={course.title}
            style={{ width: "100%", maxWidth: 453 }}
          />
        </Box>
      </Box>
      <Box style={{ marginBottom: 48 }}>
        <Typography variant={"h2"}>
          Stáhnout ukázku ze sbírky příkladů for free
        </Typography>
        <Typography>
          Kousek sbírky ti ukážu zadáčo. Fakt to není jen první stránka s
          obsahem a dalších 30 prázdnejch stran. Celou sbírku si musíš ale
          cálnout, páč mi servisák zdražil servis na auto. Sorry jako.
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 48,
        }}
      >
        <CollectionOfExamplesExample course={course} />
      </Box>
      <Box style={{ marginBottom: 48 }}>
        <Typography variant={"h2"}>Další moje sbírky příkladů</Typography>
      </Box>
      <LpCollectionOfExamples />
    </Container>
  );
};

export default CollectionOfExamples;
